<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="block_1 flex-col">
        <div class="group_1 flex-row">
          <div class="box_2 flex-col">
            <span class="text_12">AI面试官</span>
            <div class="group_8 flex-row justify-between">
              <div class="group_9 flex-col"></div>
              <span class="text_13">提升求职效率</span>
            </div>
            <div class="group_10 flex-row justify-between">
              <div class="section_1 flex-col"></div>
              <span class="text_14">优化招聘流程</span>
            </div>
            <div class="group_11 flex-row justify-between">
              <div class="group_12 flex-col"></div>
              <span class="text_15">提高学习效率</span>
            </div>
            <div class="box_3 flex-col">
              <img
                class="image_1"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng321eaa360b73d66285bcc98f3ee5b8a677069cbd510e7d9902faf214fb05aaa6.png"
              />
            </div>
          </div>
          <div class="group_13 flex-col">
            <div class="text-wrapper_3 flex-row justify-between">
              <span class="text_3">登录</span>
              <span class="text_4">注册</span>
            </div>
            <div class="group_4 flex-col"></div>
            <div class="group_5 flex-row">
              <span class="text_5">+86</span>
              <div class="group_6 flex-col"></div>
              <span class="text_6">请输入手机号</span>
            </div>
            <div class="group_7 flex-row">
              <span class="text_7">请输入短信验证码</span>
              <div class="block_3 flex-col"></div>
              <span class="text_8">发送验证码</span>
            </div>
            <div class="image-text_4 flex-col justify-between">
              <div class="text-wrapper_2 flex-col"><span class="text_9">登录</span></div>
              <div class="text-group_4 flex-row justify-between">
                <span class="text_10">忘记密码</span>
                <span class="text_11">密码登录</span>
              </div>
            </div>
          </div>
          <div class="box_6 flex-col"><div class="box_7 flex-col"></div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />